module.exports = __webpack_public_path__ + "img/tk_code.b1875a83.png";